<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Doações" pageTitle="Doações" />
            <DonationsContent />
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader';
import PageTitle from '../Common/PageTitle';
import DonationsContent from '../Donations/DonationsContent';
import FooterArea from '../Layouts/FooterArea';

export default {
    name: 'DonationsPage',
    components: { MainHeader, PageTitle, DonationsContent, FooterArea },
    mounted() { document.body.classList.add('body-bg-f8faff'); },
};
</script>
